import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem, Modal,
  CircularProgress
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../FuncionesGenerales/DataGrid";
import CategoryIcon from "@mui/icons-material/Category";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CategoriaIngresoINMOB } from "./CategoriaIngreso";
import { ContactoIngresoINMOB } from "./ContactoIngreso";
import { TituloColor, Texto, buttonCerrar, Titulo, SubTitulodos, buttonCancelar, buttonGuardar, Input, modalStyle } from "../../Layouts/CustomStyles";
import { CrearIngresoINMOB } from "./CrearIngresoINMOB";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useIngresoTodosINMOB } from "../../Hook/Inmobiliaria/Ingresos";
import { formatCLP } from "../FuncionesGenerales/FormatoCLP";
import { BsPersonVcard } from "react-icons/bs";
import { FaTrashCan } from "react-icons/fa6";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { EditarIngresoINMOB } from "./EditarIngreso";
import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

export const TabsIngresoINMOB = () => {
  const {
    IngresosInmob,
    loadingIngresosInmob,
    refetchIngresoINMOB: fetchIngresoINMOB,
    meses,
    ingresos,
    mesSeleccionado,
    setMesSeleccionado,
    anioSeleccionado,
    setAnioSeleccionado,
    setIngresos,
    getfiltromesesyaño } = useIngresoTodosINMOB();
  const { getexcel, eliminaringreso } = useIngresoINMOB();
  const [openCategoria, setOpenCategoria] = useState(false);
  const [openContacto, setOpenContacto] = useState(false);
  const [openIngreso, setOpenIngreso] = useState(false);
  const [ingresoEditar, setIngresoEditar] = useState(null);
  const [openEditarIngreso, setOpenEditarIngreso] = useState(false);
  const [openEliminar, setOpenEliminar] = useState(false);
  const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);
  const [openDetalle, setOpenDetalle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openExcel, setOpenExcel] = useState(false);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const aniosUnicos = [...new Set(meses.map(item => item.anio))];
  const [filtroExcel, setFiltroExcel] = useState({
    mes: "",
    anio: "",
  });
  

  const source = Array.isArray(ingresos)
  ? ingresos
  : Array.isArray(IngresosInmob)
  ? IngresosInmob
  : [];

const filas = source.map((item) => {
  const cuotas = item.medios_pago?.flatMap(m => m.cuotas || []) ?? [];

    const hasCuotas = item.medios_pago?.some(
      (m) => m.cuotas && m.cuotas.length > 0
    );


    return {
      id: item.id,
      estado: item.estado,
      fecha_emision: item.fecha_emision,
      fecha_pago: item.fecha_pago,
      categoria: item.categoria?.nombre ?? "",
      descripcion: item.descripcion ?? "",
      monto_bruto: item.monto_bruto,
      iva: item.iva,
      monto_neto: item.monto_neto,
      medios_pago: item.medios_pago ?? [],
      cuotas,
      hasCuotas,
      raw: item,
    };
  });

  const handleDownloadExcel = async () => {
    try {
      setEnviandoAlert(true);

      const response = await getexcel(
        filtroExcel.mes,
        filtroExcel.anio
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const nombreMes =
        mesesNombre[filtroExcel.mes - 1] || "todos";

      link.setAttribute(
        "download",
        `ingresos_${nombreMes}_${filtroExcel.anio || "todos"}.xlsx`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      // 🔥 éxito
      setAlertMessage("Excel descargado correctamente");
      setSuccessAlertOpen(true);

      setOpenExcel(false);

    } catch (error) {
      console.error("Error descargando excel", error);

      // 🔥 error
      setAlertMessage("Error al descargar el Excel");
      setErrorAlertOpen(true);

    } finally {
      setEnviandoAlert(false); // 🔥 SIEMPRE cerrar loading
    }
  };
  const DetalleRow = ({ row }) => {
    if (!row.cuotas || row.cuotas.length === 0) return null;

    return (
      <Box
        sx={{
          width: "80%",
          maxHeight: 330,
          overflowY: "auto",
          backgroundColor: "#f9fafb",
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 1,
          position: "absolute",
          zIndex: 1
        }}
      >
        <Typography sx={{ fontWeight: 600, mb: 1, fontFamily: "Poppins" }}>
          Detalle de Cuotas
        </Typography>

        {/* HEADER */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "100px 150px 150px 200px",
            fontWeight: 600,
            borderBottom: "2px solid #ddd",
            pb: 1,
          }}
        >
          <span>N° Cuota</span>
          <span>Monto</span>
          <span>Interés (%)</span>
          <span>Fecha Pago</span>
        </Box>

        {/* FILAS */}
        {row.cuotas.map((cuota, idx) => (
          <Box
            key={idx}
            sx={{
              display: "grid",
              gridTemplateColumns: "100px 150px 150px 200px",
              borderBottom: "1px solid #eee",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <span>{cuota.numero_cuota}</span>
            <span>{formatCLP(cuota.monto_cuota)}</span>
            <span>{cuota.interes}</span>
            <span>{cuota.fecha_pago}</span>
          </Box>
        ))}
      </Box>
    );
  };
  const estadoColors = {
    REGISTRADO: "#f0ad4e",
    PAGADO: "#5cb85c",
    ANULADO: "#d9534f",
    PENDIENTE: "#eada06",
  };
  const columns = [
    {
      field: "expand",
      headerName: "Detalle",
      width: 80,
      sortable: false,
      renderCell: (params) => {
        if (params.row.isDetail) return null;

        const hasCuotas = params.row.cuotas && params.row.cuotas.length > 0;

        if (!hasCuotas) return null;

        return (
          <IconButton
            size="small"
            onClick={() =>
              setExpandedRowId(
                expandedRowId === params.row.id ? null : params.row.id
              )
            }
          >
            <CreditCardIcon
              style={{
                color: "#2a8d74",
              }}
            />
          </IconButton>
        );
      },
    },

    {
      field: "fecha_emision",
      headerName: "Fecha Emisión",
      flex: 1,
      colSpan: (params) => {
        if (params?.row?.isDetail) {
          return 13;
        }
        return 1;
      },
      renderCell: (params) => {
        if (!params.row.isDetail && expandedRowId === params.row.id) {
          return <DetalleRow row={params.row} />;
        }
        return params.value;
      },
    },

    {
      field: "fecha_pago",
      headerName: "Fecha Pago",
      flex: 1,
    },

    {
      field: "estado",
      headerName: "Estado",
      width: 180,
      renderCell: (params) => {
        if (params.row.isDetail) return null;
        let color = "#ccc";

        switch (params.value) {
          case "REGISTRADO":
            color = "#f0ad4e";
            break;
            case "ANULADO":
            color = "#fae278";
            break;
            
          case "PAGADO":
            color = "#5cb85c";
            break;
          case "NO PAGO":
            color = "#d9534f";
            break;
          case "PENDIENTE":
            color = "#4f86d9";
            break;
          default:
            color = "#ccc";
        }

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Cuadrado de color */}
            <Box
              sx={{
                width: 100,
                textAlign: 'center',

                color: '#fff',
                borderRadius: 1,
                backgroundColor: color,
              }}
            >
              <span>{params.value}</span>
            </Box>
          </Box>
        );
      },
    },

    {
      field: "categoria",
      headerName: "Categoría",
      flex: 1,
    },

    {
      field: "monto_bruto",
      headerName: "Monto",
      flex: 1,
      renderCell: (params) =>
        params.row.isDetail ? null : formatCLP(params.row.monto_bruto || "0"),
    },

    {
      field: "iva",
      headerName: "IVA",
      flex: 1,
    },

    {
      field: "monto_neto",
      headerName: "Monto Neto",
      flex: 1,
      renderCell: (params) =>
        params.row.isDetail ? null : formatCLP(params.row.monto_neto || "0"),
    },

    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 1,
    },

    {
      field: "acciones",
      headerName: "Acción",
      width: 180,
      renderCell: (params) => {
        if (params.row.isDetail) return null;

        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* VER */}
            <Tooltip title="Ver Detalle">
              <IconButton
                onClick={() => {
                  setEgresoSeleccionado(params.row.raw);
                  setOpenDetalle(true);
                }}
                sx={{ background: "#28b6c6ff" }}
              >
                <BsPersonVcard style={{ color: "#fff" }} />
              </IconButton>
            </Tooltip>

              
          <Tooltip title="Editar">
            <button
              className="edit-button"
              onClick={() => handleOpenEdit(params.row.raw)}
            >
              <svg className="edit-svgIcon" viewBox="0 0 512 512">
                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
              </svg>
            </button>
          </Tooltip>
 
            {/* ELIMINAR */}
            <Tooltip title="Eliminar">
              <button
                className="delete-button"
                onClick={() => {
                  setEgresoSeleccionado(params.row.raw);
                  setOpenEliminar(true);
                }}
              >
                <FaTrashCan className="delete-svgIcon" />
              </button>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const handleEliminarIngreso = async () => {
    try {
      setOpenEliminar(false); // cerrar confirmación
      setEnviandoAlert(true); // loading

      await eliminaringreso(egresoSeleccionado.id);

      setAlertMessage("Ingreso eliminado correctamente");
      setSuccessAlertOpen(true);

      // 🔥 refrescar tabla
      await fetchIngresoINMOB();

    } catch (error) {
      console.error("Error eliminando:", error);

      setAlertMessage("Error al eliminar el ingreso");
      setErrorAlertOpen(true);

    } finally {
      setEnviandoAlert(false);
    }
  };
  const BASE_URL = "https://contable.alerama.cl/public";

  const archivoUrl = egresoSeleccionado?.archivo
    ? `${BASE_URL}/${egresoSeleccionado.archivo}`
    : null;

 const esPDF = egresoSeleccionado?.archivo?.includes("pdf/");

const esImagen =
  archivoUrl?.match(/\.(jpg|jpeg|png|webp)$/i) && !esPDF;

  const handleOpenEdit = (row) => {
    setIngresoEditar(row);
    setOpenEditarIngreso(true);
  };

  const mesesNombre = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  return (
    <Box mt={6} p={1}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={TituloColor}>
          Ingresos Inmobiliaria Fisiomed
        </Typography>

        {/* BOTONES */}
        <Box sx={{ display: "flex", gap: 2 }}>

          {/* CATEGORÍAS */}
          <Tooltip title="Ver categorías">
            <IconButton
              onClick={() => setOpenCategoria(true)}
              sx={{
                backgroundColor: "#e3f2fd",
                width: 50,
                height: 50,
                "&:hover": { backgroundColor: "#bbdefb" }
              }}
            >
              <CategoryIcon />
            </IconButton>
          </Tooltip>

          {/* CONTACTO */}
          <Tooltip title="Contacto">
            <IconButton
              onClick={() => setOpenContacto(true)}
              sx={{
                backgroundColor: "#e8f5e9",
                width: 50,
                height: 50,
                "&:hover": { backgroundColor: "#c8e6c9" }
              }}
            >
              <ContactMailIcon />
            </IconButton>
          </Tooltip>

          {/* CREAR INGRESO */}
          <Tooltip title="Crear ingreso">
            <IconButton
              onClick={() => setOpenIngreso(true)}
              sx={{
                backgroundColor: "#fff3e0",
                width: 50,
                height: 50,
                "&:hover": { backgroundColor: "#ffe0b2" }
              }}
            >
              <AddCircleIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Descargar Excel">
            <IconButton
              onClick={() => setOpenExcel(true)}
              sx={{
                backgroundColor: "#e8eaf6",
                width: 50,
                height: 50,
                "&:hover": { backgroundColor: "#c5cae9" }
              }}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Box mt={10}>
        <Grid container spacing={2} mt={2}>
          <Grid size={4}>
            <TextField
              select
              label="Mes"
              fullWidth
              sx={Input}
              value={mesSeleccionado}
              onChange={(e) => setMesSeleccionado(e.target.value)}
            >
              {meses.map((item, index) => (
                <MenuItem key={index} value={item.mes}>
                  {mesesNombre[item.mes - 1]}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid size={4}>
            <TextField
              select
              label="Año"
              fullWidth
              sx={Input}
              value={anioSeleccionado}
              onChange={(e) => setAnioSeleccionado(e.target.value)}
            >
              {[...new Set(meses.map(item => item.anio))].map((anio, index) => (
                <MenuItem key={index} value={anio}>
                  {anio}
                </MenuItem>
              ))}
            </TextField>

          </Grid>
          <Grid size={4}>
            <Button
              variant="contained"
              onClick={async () => {
                const data = await getfiltromesesyaño(
                  mesSeleccionado,
                  anioSeleccionado
                );
                setIngresos(data);
              }}
            >
              Filtrar
            </Button>
          </Grid>
        </Grid>
        <Box mt={4} sx={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={filas}
            columns={columns}
            loading={loadingIngresosInmob}
            pageSizeOptions={[5, 10, 20]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } }
            }}
            rowsPerPageOptions={[5, 10]}
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            getRowId={(row) => row.id}
            sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
              }
            }}
          />
        </Box>
      </Box>
      {/* 🔹 DIALOG CATEGORÍAS */}
      <Dialog open={openCategoria} onClose={() => setOpenCategoria(false)} fullWidth
        maxWidth="md">
        <DialogTitle sx={Texto}>Categorías ingreso INMOB</DialogTitle>
        <DialogContent>
          <CategoriaIngresoINMOB />
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCerrar} onClick={() => setOpenCategoria(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* 🔹 DIALOG CONTACTO */}
      <Dialog open={openContacto} onClose={() => setOpenContacto(false)} fullWidth
        maxWidth="md">
        <DialogTitle sx={Texto}>Contacto  ingreso INMOB </DialogTitle>
        <DialogContent>
          <ContactoIngresoINMOB />
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCerrar} onClick={() => setOpenContacto(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* 🔹 DIALOG CREAR INGRESO */}
      <Dialog open={openIngreso} onClose={() => setOpenIngreso(false)} fullWidth maxWidth="md">
        <DialogTitle>Crear Ingreso</DialogTitle>
        <DialogContent>
          <CrearIngresoINMOB cerrarModal={() => setOpenIngreso(false)} refetchIngresos={fetchIngresoINMOB} />
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCerrar} onClick={() => setOpenIngreso(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditarIngreso} onClose={() => setOpenEditarIngreso(false)} fullWidth maxWidth="md">
        <DialogTitle>Editar Ingreso</DialogTitle>
        <DialogContent>
          <EditarIngresoINMOB ingreso={ingresoEditar} cerrarModal={() => setOpenEditarIngreso(false)} refetchIngresos={fetchIngresoINMOB} />
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCerrar} onClick={() => setOpenEditarIngreso(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openExcel} onClose={() => setOpenExcel(false)} fullWidth maxWidth="sm">

        <DialogTitle sx={Texto}>
          Descargar Excel de Ingresos
        </DialogTitle>

        <DialogContent>

          <Box display="flex" flexDirection="column" gap={2} mt={1}>

            {/* MES */}
            <TextField
              select
              label="Mes"
              fullWidth
              sx={Input}
              value={filtroExcel.mes}
              onChange={(e) =>
                setFiltroExcel({
                  ...filtroExcel,
                  mes: Number(e.target.value)
                })
              }
            >
              {meses.map((item, index) => (
                <MenuItem key={index} value={item.mes}>
                  {mesesNombre[item.mes - 1]}
                </MenuItem>
              ))}
            </TextField>

            {/* FECHA INICIO */}
            <TextField
              select
              label="Año"
              fullWidth
              sx={Input}
              value={filtroExcel.anio}
              onChange={(e) =>
                setFiltroExcel({
                  ...filtroExcel,
                  anio: Number(e.target.value)
                })
              }
            >
              {[...new Set(meses.map((item) => item.anio))].map((anio, index) => (
                <MenuItem key={index} value={anio}>
                  {anio}
                </MenuItem>
              ))}
            </TextField>


          </Box>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenExcel(false)} sx={buttonCerrar}>
            Cancelar
          </Button>

          <Button
            variant="contained"
            onClick={handleDownloadExcel}
          >
            Descargar
          </Button>

        </DialogActions>

      </Dialog>


      <Dialog open={openDetalle} onClose={() => setOpenDetalle(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={Titulo}>Detalle del Egreso</DialogTitle>
        <DialogContent dividers>
          {egresoSeleccionado && (

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Box>
                      <Typography variant="subtitle1" sx={SubTitulodos}>Fecha Registro: </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.fecha_emision}</Typography>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Fecha de Pago: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.fecha_pago}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Categoria Ingreso: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.categoria?.nombre}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Estado: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.estado}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >

                    <Typography variant="subtitle1" sx={SubTitulodos}>Proveedor</Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.contacto?.nombre}</Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.contacto?.empresa}</Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.contacto?.rut}</Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.contacto?.telefono}</Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.contacto?.email}</Typography>

                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Descripción: </Typography>
                    <Typography variant="body1" sx={{ ...SubTitulodos, fontWeight: 400 }}> {egresoSeleccionado.descripcion}</Typography></Grid>
                </Grid>
              </Box>


              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Información del Monto </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto Bruto</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(egresoSeleccionado.monto_bruto)}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Iva</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.iva || "0"
                      }</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto Neto</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(egresoSeleccionado.monto_neto)}</Typography>
                    </Grid>

                  </Grid>
                </Box>
              </Box>

              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Detalle del Pago  </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>

                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Medio de Pago</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.medios_pago?.[0]?.medio
                      }</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>cuenta Bancaria</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.medios_pago?.[0]?.banco}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>N° Documento de Pago </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.medios_pago?.[0]?.numero_documento
                      }</Typography>
                    </Grid>


                    {egresoSeleccionado.medios_pago?.[0]?.cuotas.length > 0 && (
                      <Grid size={12}>
                        <Box sx={{ borderRadius: 1, p: 2, mb: 2 }}>
                          <Typography variant="subtitle1" sx={SubTitulodos}>
                            Información de las cuotas
                          </Typography>

                          <hr />

                          <Box mt={2}>

                            {/* ENCABEZADO */}
                            <Grid container spacing={1} sx={{ fontWeight: 600, mb: 1 }}>
                              <Grid size={2}>
                                <Typography sx={SubTitulodos}>Cuotas</Typography>
                              </Grid>
                              <Grid size={2}>
                                <Typography sx={SubTitulodos}>Monto</Typography>
                              </Grid>
                              <Grid size={2}>
                                <Typography sx={SubTitulodos}>Interes</Typography>
                              </Grid>
                              <Grid size={2}>
                                <Typography sx={SubTitulodos}>fecha de emision</Typography>
                              </Grid>
                              <Grid size={2}>
                                <Typography sx={SubTitulodos}>fecha de pago</Typography>
                              </Grid>

                            </Grid>

                            {/* FILAS DINÁMICAS */}
                            {egresoSeleccionado.medios_pago?.[0]?.cuotas.map((dist) => (
                              <Grid
                                container
                                spacing={1}
                                key={dist.id}
                                sx={{
                                  borderBottom: '1px solid #eee',
                                  py: 1,
                                  alignItems: 'center'
                                }}
                              >
                                <Grid size={2}>
                                  <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                                    {dist.numero_cuota}
                                  </Typography>
                                </Grid>

                                <Grid size={2}>
                                  <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                                    {formatCLP(dist.monto_cuota)}
                                  </Typography>
                                </Grid>

                                <Grid size={2}>
                                  <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                                    {dist.interes}
                                  </Typography>
                                </Grid>

                                <Grid size={2}>
                                  <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                                    {dist.fecha_emision}
                                  </Typography>
                                </Grid>

                                <Grid size={2}>
                                  <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                                    {dist.fecha_pago}
                                  </Typography>
                                </Grid>

                              </Grid>
                            ))}

                          </Box>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Box>



              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Evidencias y Documentos Adjuntos
                </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>
                      <Typography sx={SubTitulodos}>Documento Adjunto</Typography>

                      {!archivoUrl && (
                        <Typography sx={{ fontWeight: 400 }}>
                          Sin archivo
                        </Typography>
                      )}

                      {esImagen && (
                        <Box mt={1}>
                          <img
                            src={archivoUrl}
                            alt="archivo"
                            style={{
                              width: "100%",
                              maxHeight: "300px",
                              objectFit: "contain",
                              borderRadius: "8px",
                              border: "1px solid #ddd"
                            }}
                          />
                        </Box>
                      )}

                      {esPDF && (
                        <Button
                          variant="contained"
                          onClick={() => window.open(archivoUrl, "_blank")}
                        >
                          Ver PDF
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Box>







            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetalle(false)} sx={buttonCancelar}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Modal open={openEliminar} onClose={() => setOpenEliminar(false)}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "#f0ad4e", fontSize: "2rem" }} />

            <p style={{ fontWeight: 600 }}>
              ¿Estás seguro de eliminar este ingreso?
            </p>

            <p style={{ fontSize: "0.9rem", color: "#666" }}>
              {egresoSeleccionado?.descripcion}
            </p>
            <p>
              <strong>Categoría:</strong> {egresoSeleccionado?.categoria?.nombre}
            </p>

            <p>
              <strong>Monto:</strong> {formatCLP(egresoSeleccionado?.monto_bruto)}
            </p>
          </section>

          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              onClick={() => setOpenEliminar(false)}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={handleEliminarIngreso}
            >
              Eliminar
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Box>
  );
};